<template>
    <div class="row p-3">
        <div class="col-12 p-2">
            <img class="img-fluid cursor-pointer" id="logo-header" src="../assets/img/favicon.png" @mouseover="mouseOverLogo()" @mouseleave="mouseLeaveLogo()" @click="changeRoute('home')">
            <img class="img-fluid d-none" id="swiss-header" src="../assets/img/swiss.png">

            <div class="hvr-outline-out hvr-grow-xs float-right cursor-pointer d-flex justify-content-center align-items-center" @click="$emit('showNavigation')">
                <i class="fas fa-bars"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "topheader",

    data() {
        return {
            overLogo: false
        }
    },

    methods: {
        mouseOverLogo() {
            if(!this.overLogo) {
                var thisObj = this;
                this.$root.animejs({
                    targets: '#swiss-header',
                    opacity: [0, 1],
                    duration: 500,
                    easing: 'easeInOutQuad',
                    begin: function(anim) {
                        thisObj.overLogo = true;
                        $("#swiss-header").removeClass("d-none");
                    }
                });
            }
        },

        mouseLeaveLogo() {
            if(this.overLogo) {
                var thisObj = this;
                this.$root.animejs({
                    targets: '#swiss-header',
                    opacity: 0,
                    duration: 500,
                    easing: 'easeInOutQuad',
                    complete: function(anim) {
                        $("#swiss-header").addClass("d-none");
                        thisObj.overLogo = false;
                    }
                });
            }
        },

        changeRoute(newRoute) {
            var thisObj = this;

            if(thisObj.$route.name != newRoute) {
                var animation = this.$root.animejs.timeline({loop: false})
                .add({
                    targets: '#content-view',
                    opacity: 0,
                    easing: "easeInOutQuad",
                    duration: 500,
                    complete: function(anim) {
                        thisObj.$root.resetTransitionRouterView();
                        thisObj.$router.push({name: newRoute});
                        thisObj.$root.changeRouteView();
                    }
                })
                .add({
                    targets: '#content-view',
                    opacity: [0, 1],
                    easing: "easeInOutQuad",
                    duration: 500
                });
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/topheader.vue